import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {useSelector} from "react-redux"
import {StoreState} from "../Store"
import {BranchDTO} from "../../types/branch/BranchDTO";

export interface StateProps {
    token: string | null;
    teletechToken: string | null;
    mainBranch: BranchDTO | null | undefined
}

const initialState: StateProps = {
    token: null,
    teletechToken: null,
    mainBranch: null
}


const authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        // Изменить токен
        updateToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload
        },
        // Изменить токен
        updateTeletechToken: (state, action: PayloadAction<string>) => {
            state.teletechToken = action.payload
        },
        // Изменить токен
        updateMainBranch: (state, action: PayloadAction<BranchDTO | null | undefined>) => {
            state.mainBranch = action.payload
        }
    }
})

export default authSlice.reducer
// Обновить токен
export const {updateToken, updateTeletechToken, updateMainBranch} = authSlice.actions
// Получить токен
export const useGetAuthToken = () => useSelector((state: StoreState) => state.auth.token)
export const useGetMainBranch = () => useSelector((state: StoreState) => state.auth.mainBranch)
